import UI5Element from "sap/ui/core/Element";
import InputBase from "sap/m/InputBase";
import Control from "sap/ui/core/Control";
import Select from "sap/m/Select";
import { ValueState } from "sap/ui/core/library";
import Field, { Field$ChangeEvent } from "sap/ui/mdc/Field";

export default class ValidationUtil {
  public static getRequiredFieldsFromControl(control:UI5Element):Control[]{
    return control.findElements(true).filter(element => (element instanceof InputBase || element instanceof Select) && element.getRequired() === true) as Control[];
  }
  public static hasEmptyRequiredFields(control:UI5Element):boolean{
    const requiredFields:Control[] = this.getRequiredFieldsFromControl(control);
    let errors:boolean = false;

    requiredFields.forEach((field: any) => {
      let value:any;
      if(!field.getVisible()){
       return;
      }
      if(field instanceof Select){
        value = field.getSelectedKey();
      } else if(field instanceof InputBase){
        value = field.getValue();
      }
      if(!value){
        errors = true;
        field.setValueState(ValueState.Error)
      } else {
        field.setValueState(ValueState.None);
      }

    });
    return errors;
  }
  public static clearRequiredFields(control:UI5Element){
    const requiredFields:Control[] = this.getRequiredFieldsFromControl(control);
    requiredFields.forEach((field:any) => {
      field.setValueState(ValueState.None);
    });
  }
  public static validateMdcFieldInput(event:Field$ChangeEvent){
    const field :Field= event.getSource();
    const valid:boolean = !!event.getParameter("valid");
    const valueState:ValueState = valid ? ValueState.None : ValueState.Error;

    field.setValueState(valueState);
  }
}